module.exports = __webpack_public_path__ + "static/media/blueCircle.3f08c5c2.svg";